require(139);
var $Object = require(60).Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};
